import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { InputSearchComponent } from '../../../controls/input-search/input-search.component';
import { AsientoContable } from '../../../models/asiento-contable';
import { Pagination } from '../../../models/pagination';
import { AsientoContableService } from '../../../services/asiento-contable.service';

@Component({
  selector: 'app-asiento-contable-modal',
  templateUrl: './asiento-contable-modal.component.html',
  styleUrls: ['./asiento-contable-modal.component.css'],
  providers: [
    AsientoContableService,
  ],
})
export class AsientoContableModalComponent implements OnInit {
  @Output() sendAsiento = new EventEmitter();
  @ViewChild(InputSearchComponent) inputSearch: InputSearchComponent;
  public asientosContables: Array<AsientoContable>;
  public asientoContable: AsientoContable;
  public pagination: Pagination;
  
  public text: String;
  public selectedRow: number;
  public loading: boolean;
  constructor(
    private asientoContableService: AsientoContableService,
    public bsModalRef: BsModalRef,
  ) {
    this.asientosContables = [];
    this.asientoContable = new AsientoContable();
    this.pagination = new Pagination();
    this.text = "";
    this.loading = false;
  }

	ngOnInit() {
		this.getAsientosContables();

	}
	ngAfterViewInit(){
		this.inputSearchListen();
	}

	inputSearchListen(){
		this.inputSearch.onSearch.subscribe(
			res => {
				this.text = res;
			},
			err => {
				//
			}
		);
	}

 	getAsientosContablesBySearch(text){
		let qs = "&q[codigo]=" + text;
		this.pagination.current_page = 1;
		this.getAsientosContables(qs);
	}

	getCodigo(asientoContable){
		return (asientoContable.is_automatico) ? (asientoContable.tipotransaccion?asientoContable.tipotransaccion.etiqueta:'') + '-' + this.fill(asientoContable.codigo, 8) : this.fill(asientoContable.codigo, 8);
	}
	
	fill (number, len) {
		if(number.length < 8)
		  return "0".repeat(len - number.toString().length) + number.toString();
		return number;
	
	}
	getAsientosContables(qs = "") {
    this.loading = true;
		this.asientoContableService.getAll('?page='+this.pagination.current_page+'&per_page=10&embed=tipocomprobante,tipotransaccion' + qs).subscribe(
			res => {
        this.loading = false;
				this.asientosContables = res.data;
				this.pagination.current_page = res.current_page;
				this.pagination.from = res.from;
				this.pagination.to = res.to;
				this.pagination.total = res.total;
				this.pagination.last_page = res.last_page;
				this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
				this.pagination.prev_disabled = this.pagination.current_page === 1;
			},
			err => {
        this.loading = false;
				this.asientosContables = [];
			}
		);
	}

	next(){
		this.pagination.current_page++;
		this.getAsientosContables();
	}

	prev(){
		this.pagination.current_page--;
		this.getAsientosContables();
	}

	first(){
		this.pagination.current_page = 1;
		this.getAsientosContables();
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getAsientosContables();
	}

	onSelectRow(asientoContable, i) {
		
		this.selectedRow = i;
		
		this.asientoContable = asientoContable;
	}

	onDBLClick(proveedor,i)
	{
		this.onSelectRow(proveedor,i);
		this.onSubmit();
	}

	onSubmit() {
		
		this.sendAsiento.emit(this.asientoContable);
		
		this.bsModalRef.hide();
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/asiento-contable-modal/asiento-contable-modal.component.ts